const hashRegex = `#(.+)`;

export const getUrlHash = (url: string | null = '') => (!!url && url.match(hashRegex)?.[1]) || '';
